var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistributeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 24C8.86667 24 8 23.1333 8 22C8 20.8667 8.86667 20 10 20C11.1333 20 12 20.8667 12 22C12 23.1333 11.1333 24 10 24ZM10 21.3333C9.6 21.3333 9.33333 21.6 9.33333 22C9.33333 22.4 9.6 22.6667 10 22.6667C10.4 22.6667 10.6667 22.4 10.6667 22C10.6667 21.6 10.4 21.3333 10 21.3333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24C20.8667 24 20 23.1333 20 22C20 20.8667 20.8667 20 22 20C23.1333 20 24 20.8667 24 22C24 23.1333 23.1333 24 22 24ZM22 21.3333C21.6 21.3333 21.3333 21.6 21.3333 22C21.3333 22.4 21.6 22.6667 22 22.6667C22.4 22.6667 22.6667 22.4 22.6667 22C22.6667 21.6 22.4 21.3333 22 21.3333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C14.8667 24 14 23.1333 14 22C14 20.8667 14.8667 20 16 20C17.1333 20 18 20.8667 18 22C18 23.1333 17.1333 24 16 24ZM16 21.3333C15.6 21.3333 15.3333 21.6 15.3333 22C15.3333 22.4 15.6 22.6667 16 22.6667C16.4 22.6667 16.6667 22.4 16.6667 22C16.6667 21.6 16.4 21.3333 16 21.3333Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C14.8667 12 14 11.1333 14 10C14 8.86667 14.8667 8 16 8C17.1333 8 18 8.86667 18 10C18 11.1333 17.1333 12 16 12ZM16 9.33333C15.6 9.33333 15.3333 9.6 15.3333 10C15.3333 10.4 15.6 10.6667 16 10.6667C16.4 10.6667 16.6667 10.4 16.6667 10C16.6667 9.6 16.4 9.33333 16 9.33333Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9987 21.3333C21.5987 21.3333 21.332 21.0666 21.332 20.6666V17.3333C21.332 16.9333 21.0654 16.6666 20.6654 16.6666H11.332C10.932 16.6666 10.6654 16.9333 10.6654 17.3333V20.6666C10.6654 21.0666 10.3987 21.3333 9.9987 21.3333C9.5987 21.3333 9.33203 21.0666 9.33203 20.6666V17.3333C9.33203 16.2 10.1987 15.3333 11.332 15.3333H20.6654C21.7987 15.3333 22.6654 16.2 22.6654 17.3333V20.6666C22.6654 21.0666 22.3987 21.3333 21.9987 21.3333Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 21.3333C15.5987 21.3333 15.332 21.0666 15.332 20.6666V16C15.332 15.6 15.5987 15.3333 15.9987 15.3333C16.3987 15.3333 16.6654 15.6 16.6654 16V20.6666C16.6654 21.0666 16.3987 21.3333 15.9987 21.3333Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 16.6667C15.5987 16.6667 15.332 16.4 15.332 16V11.3334C15.332 10.9334 15.5987 10.6667 15.9987 10.6667C16.3987 10.6667 16.6654 10.9334 16.6654 11.3334V16C16.6654 16.4 16.3987 16.6667 15.9987 16.6667Z",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 1,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 22,
    r: 1,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 22,
    r: 1,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 1,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributeIcon);
export default __webpack_public_path__ + "static/media/distributeIcon.4841de9c.svg";
export { ForwardRef as ReactComponent };